import type { EgressStrategy } from '@terra/shared-contracts-external-network';
import {
  SYNTHETIC_EDGE_TYPES,
  type AssetNodeData,
  type SyntheticEdgeType,
} from './constants';

export type ExternalNetworkGraphVantagePoint =
  | { kind: 'INTERNET' }
  | { kind: 'CONNECTOR'; label: string };

export const INTERNET_VANTAGE_POINT: ExternalNetworkGraphVantagePoint = {
  kind: 'INTERNET',
};

export const resolveExternalNetworkGraphVantagePoint = ({
  egressStrategy,
  connectorLabel,
}: {
  egressStrategy: EgressStrategy | undefined;
  connectorLabel: string;
}): ExternalNetworkGraphVantagePoint =>
  egressStrategy === 'CONNECTOR'
    ? { kind: 'CONNECTOR', label: connectorLabel }
    : INTERNET_VANTAGE_POINT;

export const buildVantagePointRoot = (
  vantagePoint: ExternalNetworkGraphVantagePoint,
): { data: AssetNodeData; edgeType: SyntheticEdgeType } =>
  vantagePoint.kind === 'CONNECTOR'
    ? {
        data: {
          label: vantagePoint.label,
          entityKind: 'CONNECTOR',
          signalsCount: 0,
        },
        edgeType: SYNTHETIC_EDGE_TYPES.REACHES,
      }
    : {
        data: { label: 'Internet', entityKind: 'INTERNET', signalsCount: 0 },
        edgeType: SYNTHETIC_EDGE_TYPES.EXPOSES,
      };
